import styled from '@emotion/styled';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { InputAdornment } from '@mui/material';
import { DatePickerProps } from '@mui/x-date-pickers';
import React, { useState } from 'react';
import { DatePicker } from '../FormComponents/Components/DatePicker';

const StyledDatePicker = styled(DatePicker)`
  .MuiInputBase-root {
    &.MuiFilledInput-root {
      background-color: #3db1571a;
    }
  }
`;

type Props = Omit<DatePickerProps<unknown, Date>, 'renderInput'>

const DatePickerArrowIcon = ({ open }: { open: boolean }) => {
  return (
    <InputAdornment position="end">
      <KeyboardArrowDownIcon
        color="secondary"
        sx={{
          transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          transform: open ? 'rotate(180deg)' : '',
        }}
      />
    </InputAdornment>
  );
};

const CustomDatePicker = ({ label, disabled, value, onChange, minDate, maxDate, InputProps, ...props }: Props) => {
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  return (
    <StyledDatePicker
      label={label}
      variant="filled"
      InputProps={{
        disableUnderline: true,
        endAdornment: <DatePickerArrowIcon open={datePickerOpen} />,
        ...InputProps,
      }}
      onChangeOpen={setDatePickerOpen}
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      endYear={new Date().getFullYear() + 1}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default CustomDatePicker;
